import { c as _c } from "react/compiler-runtime";
import InfoIcon from "@/assets/icons/info.svg";
import { TOOLTIP_TEXTS } from "@/constants/tooltip-texts";
import { Checkbox, DetailSection, Tooltip } from "@/shared/ui";
import type { Profile } from "@/features/auth/api/types";
import classes from "../account-drawer.module.scss";
type AccountSettingsSectionProps = Readonly<{
  profile: Profile;
  isLoading: boolean;
  marketingConsent: boolean;
  onMarketingConsentChange: (value: boolean) => void;
  onViewPrivacyNotice: () => void;
  onResetPassword: () => void;
}>;
export function AccountSettingsSection(t0) {
  const $ = _c(18);
  const {
    profile,
    isLoading,
    marketingConsent,
    onMarketingConsentChange,
    onViewPrivacyNotice,
    onResetPassword
  } = t0;
  if (!isLoading && profile.accountType !== "STREAMER") {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={classes.panelRowLabel}><span className={classes.panelRowLabelText}>Password</span></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onResetPassword) {
    t2 = <div className={classes.panelRow}>{t1}<div className={classes.panelRowValue}><button type="button" onClick={onResetPassword} className={classes.resetLink}>Reset</button></div></div>;
    $[1] = onResetPassword;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={classes.panelDivider} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={classes.panelRowLabel}><span className={classes.panelRowLabelText}>Privacy Notice</span></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onViewPrivacyNotice) {
    t5 = <div className={classes.panelRow}>{t4}<div className={classes.panelRowValue}><button type="button" onClick={onViewPrivacyNotice} className={classes.resetLink}>View</button></div></div>;
    $[5] = onViewPrivacyNotice;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={classes.panelDivider} />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className={classes.panelRowLabelText}>Marketing Consent</span>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={classes.panelRowLabel}>{t7}<Tooltip content={TOOLTIP_TEXTS.account.marketingConsent}><span className={classes.infoIconButton}><InfoIcon width={14} height={14} /></span></Tooltip></div>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== isLoading || $[11] !== marketingConsent || $[12] !== onMarketingConsentChange) {
    t9 = <div className={classes.panelRow}>{t8}<div className={classes.panelRowValue}><Checkbox checked={marketingConsent} onCheckedChange={onMarketingConsentChange} isLoading={isLoading} /></div></div>;
    $[10] = isLoading;
    $[11] = marketingConsent;
    $[12] = onMarketingConsentChange;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t2 || $[15] !== t5 || $[16] !== t9) {
    t10 = <DetailSection label="ACCOUNT SETTINGS"><div className={classes.panel}>{t2}{t3}{t5}{t6}{t9}</div></DetailSection>;
    $[14] = t2;
    $[15] = t5;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}